<template>

  <b-form-group
    :label="label"
    :label-for="id"
    class="bold-label mb-4"
    :state="inputValue.state"
    :invalid-feedback="inputValue.invalidFeedback">
    <div v-if="info">{{info}}</div>
    <b-form-input
      :id="id"
      v-model="inputValue.value"
      type="number"
      :min="min"
      :max="max"
      :step="step"
      :placeholder="placeholder"
      :required="isRequired"
      :disabled="isDisabled"
      :state="inputValue.state"
      v-on:change="removeInvalidFeedback">
    </b-form-input>
    <b-form-text>{{helpMessage}}</b-form-text>
  </b-form-group>

</template>

<script>

export default {

  name: 'NumberField',

  props: {
    inputValue: {
      type: Object,
      default: function () {
        return {
          state: null,
          invalidFeedback: null,
          value: null
        }
      },
      required: true
    },
    label: {
      type: String,
      default: null,
      required: true
    },
    id: {
      type: String,
      default: null,
      required: true
    },
    min: {
      type: Number,
      default: null
    },
    max: {
      type: Number,
      default: null
    },
    step: {
      type: Number,
      default: 1
    },
    placeholder: {
      type: String,
      default: null
    },
    isRequired: {
      type: Boolean,
      default: false
    },
    isDisabled: {
      type: Boolean,
      default: false
    },
    info: {
      type: String,
      default: null
    },
    helpMessage: {
      type: String,
      default: null
    }
  },

  methods: {

    removeInvalidFeedback () {
      this.inputValue.state = null
      this.inputValue.invalidFeedback = null
    }

  }

}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/b122/editFields/NumberField.vue